import type {
	CreateReportScheduleInput,
	ReportSchedule,
	ReportScheduleListItem,
	ReportScheduleStatus,
	ReportType,
} from '@xweather/protect-types'
import { asQueryParam, type Impersonation } from '../impersonation.ts'
import { AnalyzeApi, getAllPages } from './api.ts'
import type { AssetShape } from './assetVrns.ts'
import { postCreateInput } from './reports.ts'

const schedulesPath = 'api/v2/analyze/report-schedules'

export const listAnalyzeReportSchedules = (type: ReportType, impersonation: Impersonation | undefined) =>
	getAllPages<AssetShape<ReportScheduleListItem>>(schedulesPath, { type, ...asQueryParam(impersonation) })

export const createAnalyzeReportSchedule = (input: CreateReportScheduleInput, impersonation: Impersonation | undefined) =>
	postCreateInput<AssetShape<ReportSchedule>>(schedulesPath, input, impersonation)

export const updateAnalyzeReportSchedule = (
	{ id, status }: { id: string; status: ReportScheduleStatus },
	impersonation: Impersonation | undefined,
) =>
	AnalyzeApi.patch(`${schedulesPath}/${encodeURIComponent(id)}`, {
		json: { status },
		searchParams: asQueryParam(impersonation),
	}).json<AssetShape<ReportSchedule>>()
